import styled from 'styled-components';

import {
  colorInterfaceDarkDeep,
  colorInterfaceDarkUp,
  colorInterfaceLightDown,
  colorInterfaceDarkPure,
  colorInterfaceDarkDown,
  colorStatusPositiveUp,
  colorStatusPositiveDeep,
  colorStatusPositivePure,
  colorInterfaceLightUp,
  spacingInlineXxxs,
  spacingInlineXxs,
  spacingInlineXs,
  spacingInlineSm,
  spacingInlineMd,
  borderRadiusMd,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo } from '@useblu/utils';

export const Wrapper = styled.main`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  min-width: 530px;
  max-width: 530px;
  padding: 56px 137px;

  .title {
    color: ${colorInterfaceDarkDeep};
    margin-bottom: ${spacingInlineSm};
  }

  .label {
    color: ${colorInterfaceDarkUp};
    margin-bottom: ${spacingInlineXxs};
  }

  ${breakpointTo('bpMedium')} {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 100%;
    padding: 0px;
  }
`;

export const ResumeContainer = styled.div`
  display: flex;
  gap: ${spacingInlineXs};
  margin-bottom: ${spacingInlineMd};
`;

export const Resume = styled.div`
  border: 1px solid ${colorInterfaceLightDown};
  border-radius: ${borderRadiusMd};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${spacingInlineXs};

  .resume-title {
    margin-bottom: ${spacingInlineXxxs};
  }

  .resume-value {
    color: ${colorInterfaceDarkDeep};
    margin-bottom: ${spacingInlineXxs};
  }

  .resume-caption {
    color: ${colorInterfaceDarkDown};
  }
`;

export const StepsContainer = styled.div`
  border: 1px solid ${colorInterfaceLightDown};
  border-radius: ${borderRadiusMd};
  display: flex;
  flex-direction: column;
`;

export const Step = styled.div`
  align-items: center;
  color: ${colorInterfaceDarkPure};
  display: flex;
  gap: ${spacingInlineXxs};
  padding: ${spacingInlineXs};

  .icon {
    color: ${colorStatusPositivePure};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${colorInterfaceLightDown};
  }
`;

export const StepRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingInlineXxxs};

  .step-label {
    color: ${colorInterfaceDarkPure};
    font-weight: 400;
  }
`;

export const StepFooter = styled.div`
  align-items: center;
  background-color: ${colorInterfaceLightUp};
  display: flex;
  justify-content: center;
  padding: ${spacingInlineXxs};

  &.success {
    background-color: ${colorStatusPositiveUp};
    color: ${colorStatusPositiveDeep};
  }

  .description-default {
    color: ${colorInterfaceDarkUp};
  }

  .description-positive {
    color: ${colorStatusPositiveDeep};
  }
`;

export const FooterBox = styled.div`
  width: 100%;

  ${breakpointTo('bpMedium')} {
    display: none;
  }
`;
